<template> <!-- 특수화물 선적문의 >> OOG 화물 -->
  <div class="content resize">
    <e-breadcrumbs />
    <div id="layerPop">
      <win-layer-pop>
        <component
          v-if="customComponent"
          :is="customComponent"
          :detail="detail"
          :ok-hidden="isHidden"
          @close="closePoup"
        />
      </win-layer-pop>
    </div>
    <h1 class="page_title">{{ $t('menu.MENU04.020') }}</h1>
    <form id="frm">
      <div class="content_box pb15">
        <!-- content_box -->
        <table class="tbl_search">
          <colgroup>
            <col width="70px">
            <col width="152px">
            <col width="*">
            <col width="110px">
          </colgroup>
          <tbody>
            <tr>
              <th>{{ $t('msg.SPEC030.001') }}</th> <!-- 조회정보 -->
              <td class="pr0">
                <select class="wid150" style="width:150px" v-model="param.asDtKnd" @change="optionChange()">
                  <option value="RQ">Request No.</option>
                  <option value="DT">Request Date</option>
                </select>
              </td>
              <td colspan="4">
                <div v-if="param.asDtKnd === 'RQ'">
                  <span class="form_tit"></span>
                  <input type="text" style="width:150px" v-model.trim="param.asReqNo1">
                </div>
                <div v-if="param.asDtKnd === 'DT'">
                  <e-date-range-picker
                    :id="'fromDtToDt'"
                    @change="changeDateRange"
                    :sdate="dateFrom"
                    :edate="dateTo"
                  />
                </div>
              </td>
              <td class="text_right">
                <a class="button blue sh" @click="searchData()">{{ $t('msg.CMBA100.00120') }}
                </a>
              </td>
            </tr>
            <tr style="height: 15px;" v-show="validationDt">
              <td>
              </td>
            </tr>
            <tr>
              <th>{{ $t('msg.SPEC030.006') }}</th>
              <td colspan="2">
                <e-auto-complete-place id="polPol"
                                       @change="changePol"
                                       :ctr-cd="pol.ctrCd"
                                       :plc-cd="pol.plcCd"
                                       :is-char="true"
                                       :is-char-alert="true"
                />
              </td>
              <th><span class="ml20">{{ $t('msg.SPEC030.007') }}</span></th>
              <td colspan="2">
                <e-auto-complete-place
                  id="podPod"
                  @change="changePod"
                  :ctr-cd="pod.ctrCd"
                  :plc-cd="pod.plcCd"
                  :is-char="true"
                  :is-char-alert="true"
                />
              </td>
            </tr>
            <!-- 220407 체크박스 별도 라인으로 수정 -->
            <tr>
              <td class="pl0" colspan="6">
                <div>
                  <span class="ml10">
                    <input type="checkbox" id="chk1" name="chk1" v-model="param.apvStsCd" value="02">
                    <label for="chk1"><span></span>{{ $t('msg.SPEC030.002') }}</label>
                    <input type="checkbox" id="chk2" name="chk2" v-model="param.apvStsCd" value="03">
                    <label for="chk2"><span></span>{{ $t('msg.SPEC030.003') }}</label>

                  </span>
                </div>
              </td>
            </tr>
          <!--//220407 체크박스 별도 라인으로 수정 -->
          </tbody>
        </table>
      </div>
    </form>

    <div class="content_box mt10">
      <div class="flex_box">
        <span class="tot_num">Total : <span class="num">{{ total }}</span></span>
        <span class="input_box">
          <input class="wid300"
                 type="text"
                 v-model="templateStr"
                 :placeholder="$t('msg.SPEC010G010.000')"
                 @keyup="templateEnter"
          >
        </span>
        <span class="ml_auto cal_btn"><a class="button sm" href="#" @click.prevent="exlDownload()">{{ $t('msg.MYIN020T010.016') }}</a></span> <!-- 엑셀 다운로드 -->
        <!-- <span class="ml_auto mb_tblbtn mb5">
          <a class="button sm" variant="info" @click="searchAllByDt()">All</a>
        </span> -->
      </div>
      <div id="realgrid" style="width: 100%; height: 450px">
      </div>

      <!-- <div
        v-if="gridList.length > 0"
        class="paging"
      >
        <a
          v-if="isPaging1"
          class="btn prev"
          @click.prevent="setPrevPage()"
        >Prev</a>
        <a>{{ currentPage + 1 }}/{{ totalPage }}</a>
        <a
          class="btn next"
          @click.prevent="setNextPage()"
        >Next</a>
      </div> -->
    </div>

    <!-- content_box // -->
    <!-- <div style="height:45px"></div> -->
    <div class="flex_box mt10">
      <a class="button lg" @click="openPopup('oogDetailPop', 'btnClickDetail',btnReqNo)">{{ $t('msg.SPEC020G010.000') }}</a>
      <a class="button blue lg ml_auto" @click="openPopup('OogDgInquiryPop', 'btnClickInquiry')">{{ $t('msg.CSBK140.005') }}</a>
    </div>
  </div>
</template>

<script>
import { createGrid } from '@/plugins/realgridUtil'
import Oogs from '@/api/rest/trans/oogs'
import EBreadcrumbs from '@/components/common/EBreadcrumbs'
import EAutoCompletePlace from '@/components/common/EAutoCompletePlace'
import { rootComputed } from '@/store/helpers'
import JSZip from 'jszip'
import moment from 'moment'

let gridView = null
let provider = null

export const fields = [
  { fieldName: 'reqNo', dataType: 'text' },
  { fieldName: 'reqDt', dataType: 'text' },
  { fieldName: 'polPortCd', dataType: 'text' },
  { fieldName: 'podPortCd', dataType: 'text' },
  { fieldName: 'cntrSzCd', dataType: 'number' },
  { fieldName: 'cntrTypCd', dataType: 'text' },
  { fieldName: 'len', dataType: 'number' },
  { fieldName: 'widt', dataType: 'number' },
  { fieldName: 'hght', dataType: 'number' },
  { fieldName: 'frgtWt', dataType: 'number' },
  { fieldName: 'cmdtNm', dataType: 'text' },
  { fieldName: 'apvStsCd', dataType: 'text' },
  { fieldName: 'polPortNm', dataType: 'text' },
  { fieldName: 'podPortNm', dataType: 'text' },
  { fieldName: 'polPortCtrCd', dataType: 'text' },
  { fieldName: 'podPortCtrCd', dataType: 'text' }
  // { fieldName: 'cmdtCdDsc', dataType: 'text' },

]

export const columns = [
  {
    name: 'reqNo',
    fieldName: 'reqNo',
    type: 'number',
    header: { text: 'REQ No.' },
    editable: false,
    width: 120,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const data = cell.value
        let str = ''
        str = '<a style="text-decoration:underline; font-weight: bold;">' + data + '</a>'
        return str
      }
    }
  },
  {
    name: 'reqDt',
    fieldName: 'reqDt',
    type: 'text',
    header: { text: 'Date' },
    editable: false,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
          let data = cell.value
          let str = ''
          data = data.substring(0, 4) + '.' + data.substring(4, 6) + '.' + data.substring(6, 8)
          str = '<span>' + data + '</span>'
          return str
      }
    }
},
  // { name: 'polPortCd', fieldName: 'polPortCd', type: 'text', header: { text: 'POL' }, editable: false },
  // { name: 'podPortCd', fieldName: 'podPortCd', type: 'text', header: { text: 'POD' }, editable: false },
  {
    name: 'polPortNm',
    fieldName: 'polPortNm',
    type: 'text',
    header: { text: 'POL' },
    editable: false,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const data = cell.value
        const idx = cell.index.dataRow
        const polPortCtrCd = grid.getValue(idx, 'polPortCtrCd')

        // 출발, 도착 name 수정
        let polPortNm = data
        polPortNm = data.split(',')
        polPortNm = polPortNm[0] + ',' + polPortCtrCd

        let str = ''
        str = polPortNm
        return str
      }
    }
  },
  {
    name: 'podPortNm',
    fieldName: 'podPortNm',
    type: 'text',
    header: { text: 'POD' },
    editable: false,
    renderer: {
      type: 'html',
      callback: function (grid, cell, w, h) {
        const data = cell.value
        const idx = cell.index.dataRow
        const podPortCtrCd = grid.getValue(idx, 'podPortCtrCd')

        // 출발, 도착 name 수정
        let podPortNm = data
        podPortNm = data.split(',')
        podPortNm = podPortNm[0] + ',' + podPortCtrCd

        let str = ''
        str = podPortNm

        return str
      }
    }
  },
  { name: 'polPortCtrCd', fieldName: 'polPortCtrCd', type: 'text', header: { text: 'TYPE' }, visible: false },
  { name: 'podPortCtrCd', fieldName: 'podPortCtrCd', type: 'text', header: { text: 'TYPE' }, visible: false },
  { name: 'cntrTypCd', fieldName: 'cntrTypCd', type: 'text', header: { text: 'TYPE' }, editable: false },
  {
   name: 'cntrSzCd',
   type: 'number',
   fieldName: 'cntrSzCd',
   header: {
     text: 'SIZE'
   },
   editable: false,
   numberFormat: '##'
   },
  {
    name: 'len',
    fieldName: 'len',
    header: { text: 'Length(cm)' },
    editable: false,
    numberFormat: '#,##0.##' //소수부는 2자리까지만 입력가능
  },
  {
    name: 'widt',
    fieldName: 'widt',
    type: 'text',
    header: { text: 'Width(cm)' },
    editable: false,
    numberFormat: '#,##0.##' //소수부는 2자리까지만 입력가능
  },
  {
    name: 'hght',
    fieldName: 'hght',
    type: 'text',
    header: { text: 'Height(kg)' },
    editable: false,
    numberFormat: '#,##0.##' //소수부는 2자리까지만 입력가능
  },
  {
    name: 'frgtWt',
    fieldName: 'frgtWt',
    type: 'text',
    header: { text: 'Weight(kg)' },
    editable: false,
    numberFormat: '#,##0.###' //소수부는 3자리까지만 입력가능
  },
  { name: 'cmdtNm', fieldName: 'cmdtNm', type: 'text', header: { text: 'Commodity' }, editable: false },
  // { name: 'cmdtCdDsc', fieldName: 'cmdtCdDsc', type: 'text', header: { text: 'CommidityDesc' }, editable: false },
  {
    name: 'apvStsCd',
    fieldName: 'apvStsCd',
    type: 'text',
    header: { text: 'STATUS' },
    editable: false,
    readonly: true,
    renderer: 'renderer_button'
  }
]

let layout = [
        'reqNo',
        'reqDt',
        // 'polPortCd',
        // 'podPortCd',
        'polPortNm',
        'podPortNm',
        'cntrSzCd',
        'cntrTypCd',
        'len',
        'widt',
        'hght',
        'frgtWt',
        'cmdtNm',
        'apvStsCd'
        ]

export default {
  name: 'OogList',
  components: {
    EBreadcrumbs,
    EAutoCompletePlace,
    EDateRangePicker: () => import('@/components/common/EDateRangePicker'),
    EDatePicker: () => import('@/components/common/EDatePicker'),
    OogDetailPop: () => import('@/pages/trans/popup/OogDetailPop'),
    OogDgInquiryPop: () => import('@/pages/trans/popup/OogDgInquiryPop'),
    WinLayerPop: () => import('@/pages/trans/popup/WinLayerPop'),
    EDateRangePickerSimple: () => import('@/components/common/EDateRangePickerSimple')

  },
  data: function () {
    return {
      dateFrom: '',
      dateTo: '',
      unformattedFrom: '',
      unformattedTo: '',
      isFocus: false,
      isSearch: false,
      pageCount: 0,
      gridList: [],
      gridFilter: [],
      customComponent: null,

      pol: {
        ctrCd: '',
        plcCd: ''
      },
      pod: {
        ctrCd: '',
        plcCd: ''
      },
      startPlcCd: '',
      startPlcName: '',
      destPlcCd: '',
      startCtrCd: '',
      destCtrCd: '',
      destPlcName: '',
      startPolName: '',
      destPodName: '',

      param: {
        curPage: 1, // 현재 페이지
        pageSize: 15, // 한 페이지당 게시글 수
        bkgShprCstNo: 'KMT001',
        asDtKnd: 'DT',
        asFromDt: '',
        asToDt: '',

        asReqNo: '',
        asReqNo1: '',
        asReqNo2: '',
        asReqNo3: '',

        asPolPlcCd: '',
        asPodPlcCd: '',
        apvStsCd: ['01, 04', '02', '03']
        // asChk1: 'Y',
        // asChk2: 'Y',
        // asChk3: 'Y'
      },
      // 상세 관련 DATA
      toggleValue: '',
      detail: [{ }],
      btnReqNo: '',
      isHidden: true,
      arrReqNo: [],
      total: 0,
      templateStr: '',

      //그리드 변수
      isPaging1: true,
      currentPage: 0,
      totalPage: 0,
      mUserName: '',
      mNumber: '',

      validationDt: false,
      relYn: true
    }
  },
  computed: {
    ...rootComputed
  },
  created () {
    window.functionOutsideVue(this)
    window.thisOog = this

    // 검색 날짜 최근 3개월 세팅
    this.optionChange()
  },
  destroyed () {
    window.removeEventListener('keydown', this.handleKeydown)
  },
  mounted: function () {
    console.log('mounted')
    //엑셀 다운로드용 JSZip 셋팅
    window.JSZip = window.JSZip || JSZip

    const grid = createGrid('realgrid', {
      fields,
      columns,
      layout,
      // 헤더 높이 조정
      header: { heights: [45] },
      displayOptions: {
        rowHeight: 35,
        fitStyle: 'even'
      },
      stateBar: { visible: false },
      rowIndicator: { visible: false },
      checkBar: { visible: true, exclusive: false }
    })
    gridView = grid.gridView
    provider = grid.provider

    // gridView.setDisplayOptions({
    //   rowResizable: true,
    //   rowHeight: 34,
    //   fitStyle: 'evenFill'
    // })

    // 헤더 다국어 적용
    this.setMessageProperty()

    //페이징
    // gridView.setPaging(true, 10)

    const $vm = this

    gridView.onCellItemClicked = function (grid, index, clickData) {
      let checkCurrent = gridView.getCurrent()
      if (checkCurrent.fieldName === 'reqNo') {
         let clickedReqNo = clickData.value
         $vm.openPopup('OogDetailPop', 'cellClickDetail', clickedReqNo)
      }
    }
    // $vm.gridCellStyle()
    $vm.customRender()
    this.$nextTick(function () {
      window.addEventListener('keydown', this.handleKeydown)
    })
  },
  methods: {
    handleKeydown (e) {
      // JamSin
      if (this.relYn) {
        if (e.key === 'Enter') {
          this.searchData()
        }
      }
    },
    setMessageProperty () {
    // 컬럼 헤더 텍스트 적용
      var polPortNm = gridView.getColumnProperty('polPortNm', 'header')
      var podPortNm = gridView.getColumnProperty('podPortNm', 'header')

      polPortNm.text = this.$t('msg.FARE010T010.001')
      podPortNm.text = this.$t('msg.FARE010T010.002')

      gridView.setColumnProperty('polPortNm', 'header', polPortNm)
      gridView.setColumnProperty('podPortNm', 'header', podPortNm)
    },
    //상세 페이지 활성화
    moveDetail (reqNo) {
        console.log('moveDetail')
        //상세활성화 토글
        this.toggleChange(reqNo)

        if (this.toggleValue) {
            //rest api 호출
            const detail = Oogs.getOogDetail(reqNo)

            detail.then((data) => {
                const detailData = data.data
                // console.log('detailData ::: ', detailData)

                this.detail = detailData
            })
        }
    },
    //목록 및 타이틀 클릭시 상세 토글 기능('return' 값은 목록 클릭시 파라미터)
    toggleChange (reqNo) {
        this.toggleValue = (reqNo === this.toggleValue) || reqNo === 'return' ? '' : reqNo
    },
    changeDateRange (s, d) {
      this.dateFrom = s
      this.dateTo = d

      this.unformattedFrom = moment(s).format('YYYY-MM-DD')
      this.unformattedTo = moment(d).format('YYYY-MM-DD')

      this.checkSearchValidation('fromDtToDt')
    },
    checkSearchValidation (id) {
      const searchParams = this.param
      const frm = document.querySelector('#frm')
      let selector = frm.querySelector('#' + id)
      let isOk = true

      if (selector === null || selector === undefined) {
        return true
      }

      // this.$ekmtcCommon.hideErrorTooltip(selector)
      this.localHideErrorTooltip(selector)

      switch (id) {
        case 'fromDtToDt':
          // if (searchParams.asDtKnd === 'DT' && (this.$ekmtcCommon.isEmpty(searchParams.asFromDt) || this.$ekmtcCommon.isEmpty(searchParams.asToDt))) {
          //   this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.CSBK100.147'))
          //   isOk = false
          // } else
          var fromDt = new Date(this.unformattedFrom)
          var toDt = new Date(this.unformattedTo)

          if (searchParams.asDtKnd === 'DT' && fromDt > toDt) {
            this.LocalShowErrorTooltip(selector, this.$t('msg.ONEX010T010.128'))
            // this.$ekmtcCommon.showErrorTooltip(selector, this.$t('msg.ONEX010T010.128'))
            isOk = false
          }
          break
      }
      return isOk
    },
    LocalShowErrorTooltip (elem, message) {
          this.validationDt = true

          let $elem = $(elem)
          let $parent = $elem.parents('td, div').eq(0)
          let $parentTd = $parent.parents('td,div').eq(0)
          let $parentLi = $elem.parents('li').eq(0)

          $elem.addClass('input_error')
          let $sMsgBox = ''
          let $msgBox = ''

          // $parentTd.addClass('position_relative')
          $msgBox = $parent.find('.tooltip_essen_box')

          if ($sMsgBox.length === 0) {
            $msgBox = $('<p class=\'tooltip_essen_box\'><span class=\'tooltip_essen\'></span></p> ')
            $msgBox.appendTo($parentLi)
          }
          $msgBox.find('.tooltip_essen').eq(0).text(message).show()
    },
    localHideErrorTooltip (elem) {
          this.validationDt = false
          const $elem = $(elem)
          const $parent = $elem.parents('td, div').eq(0)
          let $parentLi = $elem.parents('li').eq(0)

          $elem.removeClass('input_error')
          $parentLi.find('.tooltip_essen').hide()
    },
    openPopup (compNm, kind, reqNo) {
      console.log('openPopup')
      this.customComponent = compNm

      if (kind === 'cellClickDetail') { // 셀 클릭 상세
        // console.log('reqNo ::: ', reqNo)
        this.arrReqNo = []
        this.arrReqNo.push(reqNo)
        this.detail = {
          reqNos: this.arrReqNo
        }
      } else if (kind === 'btnClickDetail') { // 버튼 클릭 상세
        // 그리드 값 가져오기
        // var checkedItems = gridView.getCheckedItems(true)
        let rows = gridView.getCheckedRows(true)

        let checkedRowCnt = rows.length
        this.arrReqNo = []

        if (checkedRowCnt === 0) {
          this.openAlert('Please select request no')
          return
        } else {
          for (let i = 0; i < checkedRowCnt; i++) {
            var rrr = provider.getValue(rows[i], 'reqNo')
            this.arrReqNo.push(rrr)
          }
          // this.param.asReqNo = this.arrReqNo.join(';')
          this.param.asReqNo = this.arrReqNo

          //reqNo = this.btnReqNo
          this.detail = {
            reqNos: this.param.asReqNo
          }
        }
       }

      // this.$ekmtcCommon.layerOpen()
      // 팝업 후처리
      $('#layerPop > .popup_dim').fadeIn()
      $('body,html').css('overflow', 'hidden')
    },
    closePoup (e) {
      this.customComponent = null

      if (e === 'rs') {
       // 데이터 재조회
       this.searchData('closeResearch')
      }
        $('#layerPop > .popup_dim').fadeOut()
        $('body,html').removeAttr('style')
    },
    closeFun () {
      this.$Simplert.close()
    },
    openAlert (msg) {
      let obj = {
        alertType: 'simple',
        onClose: this.closeFun,
        customCloseBtnClass: 'button blue lg simplert-test1',
        customCloseBtnText: this.$t('msg.SPEC010G010.009'),
        useIcon: false,
        customClass: 'simple_alert',
        message: msg,
        type: 'info'
      }
      this.$ekmtcCommon.alert(obj)
    },
    optionChange () {
      if (this.param.asDtKnd === 'DT') {
        // startDate 세팅
        var sdate = new Date()
        var startDate = new Date(sdate.setMonth(sdate.getMonth() - 3))
        console.log(' >>>> optionChange <<<<< ', startDate)
        console.log(' >>>> optionChange getMonth <<<<< ', startDate.getMonth())
        console.log(' >>>> optionChange getDate <<<<< ', startDate.getDate())

        var edate = new Date()
        var endDate = new Date(edate.getFullYear(), edate.getMonth() + 1, edate.getDate())
        var month = ''
        var day = ''

        if (String(startDate.getMonth()) === '0') {
          month = '01'
        } else {
          if (String(startDate.getMonth() + 1).length === 1) {
            month = '0' + String(startDate.getMonth() + 1)
          } else {
            month = String(startDate.getMonth() + 1)
          }
        }

        if (String(startDate.getDate()).length === 1) {
          day = '0' + String(startDate.getDate())
        } else {
          day = String(startDate.getDate())
        }

        if (month === '01' && day < 15) {
          // this.dateFrom = startDate.getFullYear() + '.' + month + '.' + day
          this.dateFrom = startDate.getFullYear() + month + day
        } else {
          // this.dateFrom = startDate.getFullYear() + '.' + month + '.' + day
          this.dateFrom = startDate.getFullYear() + month + day
          this.unformattedFrom = startDate.getFullYear() + month + day
        }

        if (String(endDate.getMonth()) === '0') {
          month = '12'
        } else {
          if (String(endDate.getMonth()).length === 1) {
            month = '0' + String(endDate.getMonth())
          } else {
            month = String(endDate.getMonth())
          }
        }

        if (String(endDate.getDate()).length === 1) {
          day = '0' + String(endDate.getDate())
        } else {
          day = String(endDate.getDate())
        }

        // this.dateTo = edate.getFullYear() + '.' + month + '.' + day
        this.dateTo = edate.getFullYear() + month + day

        // datePicker 전달 value
        this.unformattedTo = edate.getFullYear() + month + day

        // 메뉴 선택 변경시 값 초기화
        this.param.asReqNo1 = ''
      }
    },
    optionChk: function () {
      if (this.param.asDtKnd === 'RQ') {
        if (this.param.asReqNo1 === '') {
            this.openAlert('Please input request no.')
            return false
        }
      } else if (this.param.asDtKnd === 'DT') {
        if (this.dateFrom === '') {
            this.openAlert('Please input start date.')
            return false
        }
        if (this.dateTo === '') {
            this.openAlert('Please input end date.')
            return false
        }
      }

      return true
    },
    searchAllByDt () {
      this.param.asDtKnd = 'DT'
      // this.optionChange()
      this.searchData()
    },
    searchData (msg) {
      // 2021.11.02 재조회시 결과내검색(필터) 초기화
      this.templateStr = ''

      let searchk = ''

      if (msg === 'closeResearch') {
        searchk = true
      } else {
        searchk = this.optionChk()
      }
      this.isSearch = true

      if (this.dateFrom !== '' && this.dateTo !== '') {
        var from = this.dateFrom.split('.').join('')
        var to = this.dateTo.split('.').join('')

        this.param.asFromDt = from
        this.param.asToDt = to

        //this.param.asFromDt = '20200101'
        //this.param.asToDt = '20211231'
      }
     if (searchk) {
        Oogs.getOogList(this.param)
          .then(response => {
            const resp = response.data
            const oogList = resp.oogList
            this.total = oogList.length

            // 2021.11.02 재조회시 그리드 초기화
            if (oogList.length !== 0) {
              this.gridList = oogList
            } else {
              this.gridList = []
            }

            provider.setRows(this.gridList)

            this.currentPage = gridView.getPage() //현재 페이지 반환
            // this.currentPage = 0
            this.totalPage = gridView.getPageCount() //전체페이지 개수 반환

            // 첫페이지로 이동
            // gridView.setPage(this.currentPage)
        })
        .catch(err => {
          console.log(err)
        })
        console.log('searchData')
     }
    },
    getValue: function () {
      var current = gridView.getCurrent()
      var value = provider.getValue(current.dataRow, current.fieldName)
      alert('row: ' +
        current.dataRow +
        '\n' +
        'field: ' +
        current.fieldName +
        '\n' +
        'value: ' +
        value
      )
    },
    changePol (vo) {
      this.pol = vo
      this.startPolName = vo.plcEnm
      this.startCtrCd = vo.ctrCd
      this.startPlcCd = vo.plcCd
      this.startPlcName = vo.plcEnm
      this.param.asPolPlcCd = vo.plcCd
      const frm = document.querySelector('#frm')
      const elem = frm.querySelector('#polPol')
      this.$ekmtcCommon.hideErrorTooltip(elem)
    },
    changePod (vo) {
      this.pod = vo
      this.destPodName = vo.plcEnm
      this.destCtrCd = vo.ctrCd
      this.destPlcCd = vo.plcCd
      this.destPlcName = vo.plcEnm
      this.param.asPodPlcCd = vo.plcCd
      const frm = document.querySelector('#frm')
      const elem = frm.querySelector('#podPod')
      this.$ekmtcCommon.hideErrorTooltip(elem)
    },
    templateEnter (e) {
      // if (e.keyCode === 13) {
        const gridList = this.gridList
        if (this.templateStr === '') {
          provider.setRows(this.gridList)
        } else {
            this.templateStr = this.templateStr.trim()
            this.gridFilter = gridList.filter(vo =>
                  (
                  (this.$ekmtcCommon.isNotEmpty(vo.reqDt) && vo.reqDt.indexOf(this.templateStr) > -1) ||
                  (this.$ekmtcCommon.isNotEmpty(vo.reqNo) && vo.reqNo.indexOf(this.templateStr) > -1) ||
                  (this.$ekmtcCommon.isNotEmpty(vo.widt) && vo.widt.indexOf(this.templateStr) > -1) ||
                  (this.$ekmtcCommon.isNotEmpty(vo.hght) && vo.hght.indexOf(this.templateStr) > -1) ||
                  (this.$ekmtcCommon.isNotEmpty(vo.frgtWt) && vo.frgtWt.indexOf(this.templateStr) > -1) ||
                  (this.$ekmtcCommon.isNotEmpty(vo.len) && vo.len.indexOf(this.templateStr) > -1) ||
                  (this.$ekmtcCommon.isNotEmpty(vo.polPortNm) && vo.polPortNm.indexOf(this.templateStr) > -1) ||
                  (this.$ekmtcCommon.isNotEmpty(vo.podPortNm) && vo.podPortNm.indexOf(this.templateStr) > -1) ||
                  (this.$ekmtcCommon.isNotEmpty(vo.cntrTypCd) && vo.cntrTypCd.indexOf(this.templateStr) > -1) ||
                  (this.$ekmtcCommon.isNotEmpty(vo.cntrSzCd) && vo.cntrSzCd.indexOf(this.templateStr) > -1) ||
                  (this.$ekmtcCommon.isNotEmpty(vo.apvStsCd) && vo.apvStsCd.indexOf(this.templateStr) > -1) ||
                  (this.$ekmtcCommon.isNotEmpty(vo.cmdtNm) && vo.cmdtNm.indexOf(this.templateStr) > -1)
                  )
            )
            provider.setRows(this.gridFilter)
        }
      // }
    },
    setPrevPage: function () {
      gridView.setPage(this.currentPage - 1)
      this.currentPage = gridView.getPage()
    },
    setNextPage: function () {
      gridView.setPage(this.currentPage + 1)
      this.currentPage = gridView.getPage()
    },
    exlDownload () {
      const curDt = moment().format('YYYYMMDD')
      gridView.exportGrid({
        type: 'excel',
        target: 'local',
        textCallback: function (index, column, value) {
          if (column === 'apvStsCd') {
            if (value === '01') {
              return '확인중'
            } else if (value === '02') {
              return '선적가능'
            } else if (value === '03') {
              return '선적불가'
            } else {
              return '확인중' // 02, 03은 확인 했으나 나머지는 확인 안됨
            }
          } else {
            return value
          }
        },
        documentTitle: { //제목
          message: this.$t('menu.MENU04.000') + '_' + this.$t('menu.MENU04.020'),
          visible: true,
          spaceTop: 1,
          spaceBottom: 1,
          height: 60,
          styleName: 'excel-export-title-style'
        },
        applyDynamicStyles: true,
        exportTemplate: true,
        //allColumns: true,
        pagingAllItems: true,
        fileName: `${this.$t('menu.MENU04.000') + '_' + this.$t('menu.MENU04.020')}_${curDt}.xlsx`,
        showProgress: false,
        progressMessage: this.$t('msg.ADD20220219.012'), // 엑셀 Export중입니다.
        indicator: 'default',
        header: 'default',
        footer: 'default',
        done: function () {
          console.log('엑셀 다운로드 완료')
        }
      })
    }, /*
    exlDownload () { // 그리드 엑셀 다운로드
      let title = `${this.$t('menu.MENU04.000')}_${this.$t('menu.MENU04.020')}`
      this.$ekmtcCommon.gridExportExcel(gridView, title)
    }, */
    customRender: function () {
      const asking = this.$t('msg.CSBK140.001')
      const pass = this.$t('msg.CSBK140.002')
      const nPass = this.$t('msg.CSBK140.003')
      const cheking = this.$t('msg.CSBK140.004')

      gridView.registerCustomRenderer('renderer_button', {
        initContent: function (parent) {
          var span = this._span = document.createElement('span')
          parent.appendChild(span)
        },
        render: function (grid, model, width, height, info) {
          info = info || {}
          var span = this._span
          // text설정.
          // span.className = 'button blue sm'
          span.textContent = model.value

          if (span.textContent === '01') {
              span.className = 'label green md minwid60'
              span.textContent = asking
          } else if (span.textContent === '02') {
              span.className = 'label blue md minwid60'
              span.textContent = pass
          } else if (span.textContent === '03') {
              span.className = 'label red md minwid60'
              span.textContent = nPass
          } else {
              span.className = 'label gray md minwid60'
              span.textContent = cheking
          }
        }
      })
    }
  }
}
</script>

 <style scoped>
.rg-table input[type="radio"], .rg-table input[type="checkbox"] {
    height: 16px !important;
}

/*https://docs.realgrid.com/guides/renderer/custom-renderer-img-buttons*/

/* a.no-uline:hover{
  text-decoration:underline !important;
} */

ul.grid{
 position:absolute;
}

span.float {
  float:right;
}
.tbl_search td {
  padding: 4px 10px 0px 10px !important;
}
 </style>
